import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { hideAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { CLOSED_APPOINTMENT_STATUSES } from 'modules/common/constants/appointmentStatuses';
import { getCurrentAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';

import createAction from './index';
import * as services from '../services/fetchAppointment';

export const FETCH_APPOINTMENT = createAsyncAction(createAction('FETCH_APPOINTMENT'));

export const fetchAppointment = (appointmentId, background = true) => (dispatch, getState) => {
  const state = getState();
  if (!background) dispatch({ type: FETCH_APPOINTMENT.pending });

  const apiCallParams = {
    query: services.FETCH_APPOINTMENT,
    variables: { appointmentId },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(response => {
      const { appointment } = response.data;
      const schedules = appointment.schedules.filter(({ status }) => status === 'CREATED');

      const { hideArchive } = state.common.organizationConfig.appointmentConfig;
      if (appointment && CLOSED_APPOINTMENT_STATUSES.includes(appointment.status) && hideArchive) {
        dispatch(hideAppointmentInfo());
      }

      dispatch({
        type: FETCH_APPOINTMENT.success,
        payload: {
          appointment: {
            ...appointment,
            schedules,
          },
        },
      });

      return {
        ...appointment,
        schedules,
      };
    })
    .catch((err) => dispatch(errorAction(FETCH_APPOINTMENT.failure, err)));
};

export const refetchCurrentAppointment = () => (dispatch, getState) => {
  const { appointmentId } = getCurrentAppointment(getState());
  return dispatch(fetchAppointment(appointmentId));
};
